module.exports = __webpack_public_path__ + "img/stock1.e34fa7e1.png";